import React from "react";
import { prop, pick, map, addIndex } from "ramda";
import PropTypes from "prop-types";
import { compose, withState, withContext, getContext } from "recompose";
import { Radio } from "components/generic/form/native";

const contextTypes = {
  active: PropTypes.number,
  setActive: PropTypes.func
};

const indexMap = addIndex(map);

const Root = compose(
  withState("active", "setActive", prop("defaultIndex")),
  withContext(contextTypes, pick(["active", "setActive"]))
)(
  compose(
    indexMap((item, index) => React.cloneElement(item, { index })),
    React.Children.toArray,
    prop("children")
  )
);

Root.Row = getContext(contextTypes)(
  ({ index, title, children, active, setActive }) => (
    <div>
      <Radio
        title={title}
        checked={index === active}
        onChange={() => setActive(index)}
      />
      <div className="pl3 pb2 f6">{index === active && children}</div>
    </div>
  )
);

export default Root;



// WEBPACK FOOTER //
// ./src/components/generic/kit/Accordion/index.js